var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "config-edit" }, [
    _c(
      "div",
      { staticClass: "dialog-body" },
      [
        _c(
          "el-form",
          {
            ref: "formconfig",
            staticStyle: {
              display: "flex",
              "flex-wrap": "wrap",
              "justify-content": "space-between",
              padding: "0 12px"
            },
            attrs: {
              "label-position": "top",
              model: _vm.formconfig,
              rules: _vm.rules,
              "label-width": "140px"
            }
          },
          [
            _vm.notaddsystem
              ? _c(
                  "el-form-item",
                  { attrs: { label: "配置名称：", prop: "configname" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          size: "small",
                          placeholder: "请选择配置名称",
                          disabled: _vm.iseditconfig
                        },
                        on: {
                          change: _vm.changeconfigname,
                          focus: _vm.namefocus
                        },
                        model: {
                          value: _vm.formconfig.configname,
                          callback: function($$v) {
                            _vm.$set(_vm.formconfig, "configname", $$v)
                          },
                          expression: "formconfig.configname"
                        }
                      },
                      _vm._l(_vm.optioncofig, function(option, i) {
                        return _c("el-option", {
                          key: i,
                          attrs: { label: option.value, value: option.key }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.notaddsystem
              ? _c(
                  "el-form-item",
                  { attrs: { label: "配置值：", prop: "configvalue" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { size: "small", placeholder: "请选择配置值" },
                        model: {
                          value: _vm.formconfig.configvalue,
                          callback: function($$v) {
                            _vm.$set(_vm.formconfig, "configvalue", $$v)
                          },
                          expression: "formconfig.configvalue"
                        }
                      },
                      _vm._l(_vm.configvaluelist, function(option, i) {
                        return _c("el-option", {
                          key: i,
                          attrs: { label: option.value, value: option.key }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            !_vm.notaddsystem
              ? _c(
                  "el-form-item",
                  { attrs: { label: "子系统名称：", prop: "system" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          size: "small",
                          placeholder: "请选择子系统名称",
                          "value-key": "systemId"
                        },
                        model: {
                          value: _vm.formconfig.system,
                          callback: function($$v) {
                            _vm.$set(_vm.formconfig, "system", $$v)
                          },
                          expression: "formconfig.system"
                        }
                      },
                      _vm._l(_vm.canaddsystemlist, function(option) {
                        return _c("el-option", {
                          key: option.systemId,
                          attrs: { label: option.systemName, value: option }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "dialog-footer" },
      [
        _c("input", {
          staticClass: "btn",
          attrs: { type: "button", value: "取消" },
          on: { click: _vm.cancelDailog }
        }),
        _c(
          "el-popconfirm",
          {
            attrs: {
              title: _vm.notaddsystem
                ? "确认新增此配置？"
                : "确认新增此子系统配置"
            },
            on: {
              onConfirm: function($event) {
                return _vm.confirmsure(true)
              },
              onCancel: function($event) {
                return _vm.confirmsure(false)
              }
            }
          },
          [
            _c("input", {
              staticClass: "btn btn-red",
              attrs: { slot: "reference", type: "button", value: "确认" },
              slot: "reference"
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }